
// Get the .click-me element
var openHelp = document.querySelector('.open-size-guide');
var closeHelp = document.querySelector('.close_overlay');
var contactModal = document.querySelector('.size-guide-overlay');

// This will run when the .click-me element is clicked
if(openHelp){
  openHelp.addEventListener('click', function (event) {
    contactModal.classList.add("overlay-is-open"); 
  });
}

if(closeHelp){
  closeHelp.addEventListener('click', function (event) {
    contactModal.classList.remove("overlay-is-open"); 
  });   
}
